import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { IndeterminateButtonLoadingDirective } from '../../directives/indeterminate-button-loading/indeterminate-button-loading.directive'
import { SvgIconComponent } from '../svg-icon/svg-icon.component'

@Component({
    selector: 'app-base-button',
    templateUrl: './app-base-button.component.html',
    styleUrls: ['./app-base-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatButtonModule, SvgIconComponent, IndeterminateButtonLoadingDirective],
})
export class AppBaseButtonComponent {
    type = input<'primary' | 'secondary' | 'basic'>('primary')
    size = input<'large' | 'medium' | 'small'>('medium')
    disabled = input<boolean>(false)
    fullWidth = input<boolean>(false)
    isLoading = input<boolean>(false)
    startIcon = input<string | undefined>(undefined)
    buttonType = input<'button' | 'submit' | 'reset'>('button')
    buttonVariant = input<'contained' | 'outlined' | 'text' | 'soft'>('contained')

    @Output() buttonClick = new EventEmitter<void>()

    onButtonClick(): void {
        if (!this.disabled() && !this.isLoading()) {
            this.buttonClick.emit()
        }
    }
}
